import {
  arrayOf,
  bool,
  customType,
  extend,
  params,
  string as stringType,
} from '@thd-nucleus/data-sources';
import { ChatMessage } from './subcomponents/ChatMessage';

export const dataModel = extend(
  {
    retrieveDetails: params({
      userContext: customType('UserContext').shape({
        userIdentities: customType('UserIdentities').shape({
          mcvisId: stringType(),
          svocId: stringType()
        }),
        sessionId: stringType(),
        storeId: stringType(),
        zipCode: stringType(),
        deviceType: stringType(),
        language: stringType()
      }),
      pageContext: customType('PageContext').shape({
        pageType: stringType(),
        referrerPage: stringType(),
        timestamp: stringType()
      }),
      questionContext: customType('QuestionContext').shape({
        itemId: stringType(),
        userQuestion: stringType(),
        recentSearchTerms: arrayOf(stringType())
      }),
      suggestedQuestions: bool(),
      followUpQuestions: bool(),
      model_name: stringType()
    }).mutation()
      .shape({
        responseSummary: customType('MagicApronResponseSummary').shape({
          summaryAnswer: stringType(),
          userQuestion: stringType()
        }),
        relatedContent: customType('MagicApronRelatedContent').shape({
          relatedSearchResults: arrayOf(customType('MagicApronRelatedSearchResults').shape({
            imageUrl: stringType(),
            href: stringType(),
            category: arrayOf(stringType()),
            searchTerm: stringType(),
            description: stringType(),
          })),
          recommendations: customType('MagicApronRecommendations').shape({
            bestMatch: arrayOf(customType('MagicApronBestMatch').shape({
              itemId: stringType()
            }))
          })
        }),
        suggestedQuestions: arrayOf(stringType()),
        followUpQuestions: arrayOf(stringType()),
        additionalDetails: customType('MagicApronAdditionalDetails').shape({
          inquiryDetails: customType('MagicApronInquiryDetails').shape({
            telephoneNumber: stringType(),
            description: stringType(),
            referenceUrl: stringType()
          })
        }),
        exceptionDetails: customType('MagicApronExceptionDetails').shape({
          details: arrayOf(stringType()),
          type: stringType(),
          message: stringType()
        })
      })
  },
  ChatMessage
);